import React from 'react';
import { usePersonalDataModal } from './hook/usePersonalDataModal';
import { ModalBase } from '../ModalBase';
import { IoShieldCheckmarkOutline } from 'react-icons/io5';
import { Input } from '../../ui/Input';
import { maskCpf } from '../../../util/mask';
import { Step1Component, Step2Component, Step3Component } from './PersonalDataSteeps';


export const PersonalDataModal = React.forwardRef((props, ref) => {
    const {
        show,
        closeModal,
        StepProgress,
        handleSubmit,
        currentStep,
        form,
        handleChange,
        errors,
        inputsPersonalData,
        checkSMSToken,
        onSubmitPassword
    } = usePersonalDataModal({ modalRef: ref });

    return (
        <ModalBase
            modalState={{
                show,
                isEdit: false,
                identifier: "",
            }}
            hiddenButton={(currentStep === 2 || currentStep === 3)}
            buttonTitle="Continuar"
            onClose={closeModal}
            funcNewItem={handleSubmit}
        // funcEditItem = (identifier) => { }
        >
            <StepProgress />
            {currentStep === 1 && <Step1Component form={form} handleChange={handleChange} errors={errors} inputsPersonalData={inputsPersonalData} />}
            {currentStep === 2 && <Step2Component form={form} checkSMSToken={checkSMSToken} />}
            {currentStep === 3 && <Step3Component onSubmitPassword={onSubmitPassword} />}
        </ModalBase>
    );
});